// State array for app.config.ts
import { AuthState } from './auth/auth.state';
import { BlogState } from './blog/blog.state';
import { BookingState } from './booking/booking.state';
import { CommunicationsState } from './communications/communications.state';
import { ConversationsState } from './conversations/conversations.state';
import { FavoritesState } from './favorites/favorites.state';
import { FleetState } from './fleet/fleet.state';
import { MessagesState } from './messages/messages.state';
import { OrganizationState } from './organization/organization.state';
import { ReviewState } from './review/review.state';
import { SearchState } from './search/search.state';
import { VehicleState } from './vehicle/vehicle.state';

export const APP_STATES = [
  AuthState,
  BlogState,
  VehicleState,
  BookingState,
  FleetState,
  MessagesState,
  ConversationsState,
  SearchState,
  FavoritesState,
  CommunicationsState,
  OrganizationState,
  ReviewState,
];
